import { InfoConfigValues } from './InfoConfigValues';

export type VehicleInfo = {
  vehicleId: string;
  make: string;
  // TODO: REMOVE ONE OF THESE DUPLICATE ATTRIBUTES AND TEST IN ALL PORTALS
  // TRACK ALL REFERENCES
  vehicleModel: string;
  model: string;
  type: string;
  color: string;
  // TODO: REMOVE ONE OF THESE DUPLICATE ATTRIBUTES AND TEST IN ALL PORTALS
  // TRACK ALL REFERENCES
  licensePlate: string;
  plateNumber: string;
  fleetNumber: string;
  licensePlateState: string;
  primaryDriverName: string;
  licensePrimaryDriver: string;
  isRental: boolean;
  destinationAddressId: string;
  year?: number;
  insuranceDocUrl?: string;
  registrationDocUrl?: string;
  name?: string;
  employeeList?: string[];
  employeeId?: string;
  insDocFileName?: string;
  regDocFileName?: string;
  identificationSource?: string;
  employeeSelectList?: string[];
  [key: string]: any;
};
export type VehicleInfoConfig = {
  [Property in keyof Omit<VehicleInfo, 'vehicleId'>]: keyof typeof InfoConfigValues;
} & {
  completeLater?: keyof typeof InfoConfigValues;
  vehicleSelect?: keyof typeof InfoConfigValues;
  employeeSelect?: keyof typeof InfoConfigValues;
};

export function newVehicleInfo(data: Partial<VehicleInfo> = {}): VehicleInfo {
  const res: VehicleInfo = {
    vehicleId: data?.vehicleId || '',
    make: data?.make || '',
    // TODO: REMOVE ONE OF THESE DUPLICATE ATTRIBUTES AND TEST IN ALL PORTALS
    // TRACK ALL REFERENCES
    licensePlate: data?.licensePlate || data?.plateNumber || '',
    plateNumber: data?.licensePlate || data?.plateNumber || '',
    // TODO: REMOVE ONE OF THESE DUPLICATE ATTRIBUTES AND TEST IN ALL PORTALS
    // TRACK ALL REFERENCES
    vehicleModel: data?.vehicleModel || data?.model || '',
    model: data?.vehicleModel || data?.model || '',
    type: data?.type || '',
    color: data?.color || '',
    fleetNumber: data?.fleetNumber || '',
    licensePlateState: data?.licensePlateState || '',
    primaryDriverName: data?.primaryDriverName || '',
    licensePrimaryDriver: data?.licensePrimaryDriver || '',
    isRental: data?.isRental || false,
    year: data?.year,
    destinationAddressId: data?.destinationAddressId || '',
    insuranceDocUrl: data?.insuranceDocUrl,
    registrationDocUrl: data?.registrationDocUrl,
    insDocFileName: data?.insDocFileName || '',
    regDocFileName: data?.regDocFileName || '',
    name: data?.name || '',
    employeeList: data?.employeeList,
    employeeId: data?.employeeId,
    identificationSource: data?.identificationSource,
    employeeSelectList: data?.employeeSelectList,
  };
  // Object.assign(res, data);
  return res;
}

export function newVehicleInfoConfig(
  data: Partial<VehicleInfoConfig> = {},
): VehicleInfoConfig {
  return {
    make: data?.make || 'required',
    // TODO: REMOVE ONE OF THESE DUPLICATE ATTRIBUTES AND TEST IN ALL PORTALS
    // TRACK ALL REFERENCES
    licensePlate: data?.licensePlate || data?.plateNumber || 'required',
    plateNumber: data?.licensePlate || data?.plateNumber || 'required',
    // TODO: REMOVE ONE OF THESE DUPLICATE ATTRIBUTES AND TEST IN ALL PORTALS
    // TRACK ALL REFERENCES
    vehicleModel: data?.vehicleModel || data?.model || 'required',
    model: data?.vehicleModel || data?.model || 'required',
    type: data?.type || 'required',
    color: data?.color || 'required',
    fleetNumber: data?.fleetNumber || 'disabled',
    licensePlateState: data?.licensePlateState || 'disabled',
    primaryDriverName: data?.primaryDriverName || 'disabled',
    licensePrimaryDriver: data?.licensePrimaryDriver || 'disabled',
    isRental: data?.isRental || 'disabled',
    name: data?.name || 'disabled',
    completeLater: data?.completeLater || 'disabled',
    employeeList: data?.employeeList || 'disabled',
    destinationAddressId: data?.destinationAddressId || 'disabled',
    employeeSelect: data?.employeeSelect || 'disabled',
    vehicleSelect: data?.vehicleSelect || 'disabled',
  };
}

export default VehicleInfo;
